import { Injectable } from '@angular/core';
import { MonotainerDetails } from '../components/3dPlanogram/inputGroup';
import { ModelLoaderService, SceneService } from '../services/index';
@Injectable({
  providedIn: 'root',
})
export class MonotainerService {
  private _monotainer: THREE.Group;
  private _zPos = -2.5;
  private _xPos = -10;
  private _yPos = 3;
  constructor(
    private _modelLoaderService: ModelLoaderService,
    private _sceneService: SceneService
  ) {}
  resetValue() {
    this._zPos = -2.5;
    this._xPos = -10;
    this._yPos = 3;
  }
  /**
   * Stacks monotainer on sort area
   * @param monotainerDetails
   */
  async stackMonotainer(monotainerDetails: MonotainerDetails[]) {
    // this.loaderService.showLoader()
    for (const monotianers of monotainerDetails) {
      await this._modelLoaderService.setMonotainer();
      const scene = this._sceneService.getScene();
      this._monotainer = this._modelLoaderService.getMonotainer();
      if (this._zPos > -6.5) {
        this._monotainer.position.set(this._xPos, this._yPos, this._zPos--);
      } else {
        this._zPos = -2.5;
        this._xPos = -6;
        this._monotainer.position.set(this._xPos, this._yPos, this._zPos--);
      }
      this._monotainer.name = monotianers.name;
      scene.add(this._monotainer);
    }
    // this.loaderService.hideLoader()
  }
}
